import { useQueryClient } from "@tanstack/react-query";
import CartPlus from "icons/CartPlus";
import HearthIcon from "icons/HearthIcon";
import LogoutIcon from "icons/LogoutIcon";
import PersonCard from "icons/PersonCard";
import { FC } from "react";
import { Link, useNavigate } from "react-router-dom";
import useAuthStore from "stores/auth";
import useUserStore from "stores/user";

interface IUserMenu {
  callback: () => void;
}

const UserMenu: FC<IUserMenu> = ({ callback }) => {
  const { resetUser } = useUserStore();
  const { resetToken } = useAuthStore();
  const queryClient = useQueryClient();

  const navigate = useNavigate();

  return (
    <div className="w-[300px] p-0">
      <Link to="/setting/user-profile">
        <div className="h-9 px-4 flex gap-4 items-center text-[#2A2A2A] hover:text-primary-500 hover:bg-primary-100">
          <PersonCard />
          <span>ข้อมูลส่วนตัว</span>
        </div>
      </Link>
      <Link to="/setting/order-history">
        <div className="h-9 px-4 flex gap-4 items-center text-[#2A2A2A] hover:text-primary-500 hover:bg-primary-100">
          <CartPlus />
          <span>รายการสั่งซื้อ</span>
        </div>
      </Link>
      {/* <Link to="">
        <div className="h-9 px-4 flex gap-4 items-center text-[#2A2A2A] hover:text-primary-500 hover:bg-primary-100">
          <DrugIcon />
          <span>Request สินค้า</span>
        </div>
      </Link> */}
      <Link to="/setting/favorite">
        <div className="h-9 px-4 flex gap-4 items-center text-[#2A2A2A] hover:text-primary-500 hover:bg-primary-100">
          <HearthIcon />
          <span>รายการโปรด</span>
        </div>
      </Link>
      {/* <Link to="/setting/referral">
        <div className="h-9 px-4 flex gap-4 items-center text-[#2A2A2A] hover:text-primary-500 hover:bg-primary-100">
          <PeopleIcon />
          <span>แนะนำเพื่อน</span>
        </div>
      </Link> */}
      <div
        className="h-9 px-4 flex gap-4 items-center text-[#2A2A2A] hover:text-primary-500 hover:bg-primary-100 cursor-pointer"
        onClick={() => {
          resetUser();
          resetToken();
          callback();
          queryClient.invalidateQueries({
            queryKey: ["getProduct"],
          });
          queryClient.invalidateQueries({
            queryKey: ["getCategory"],
          });

          queryClient.invalidateQueries({
            queryKey: ["getBannerList"],
          });
          queryClient.setQueryData(["getCart"], { cartItems: [] });
          navigate("/");
        }}
      >
        <LogoutIcon />
        <span>ออกจากระบบ</span>
      </div>
    </div>
  );
};
export default UserMenu;
